
const styles = (theme) => {
  //console.log(theme)
  return {
    hello: {
      backgroundColor: 'red'
    },
    
    paginationRoot: {
      marginTop: '15px'
    },
    filter: {
      background: 'none',
      fontSize: '14px'
    },
    tableRoot: {
      display: 'flex',
      justifyContent: 'flex-end'
    },
    page: {
      padding: '5px 10px',
      border: '1px solid',
      cursor: 'pointer',
      '&.active': {
        backgroundColor: 'grey',
      }
    },
    activePage: {
      color: 'white!important',
    },
    pagination: {
      display: 'flex',
      listStyle: 'none',
      justifyContent: 'flex-end',
      marginRight: '24px'
    },
    searchInput: {
      borderRadius: '20px',
      border: '1px solid grey',
      padding: '0 10px',
      marginBottom: '10px'
    }
  }
};

export default styles;
